<template>
  <div>
    <div class="hint_info">
      <span class=""><img src="https://static.etcmall.cn/etcissue/trucking/hint.png" class="hint"></span>
      <span>已加载,当前无消息!</span>
    </div>
    <div class="hint_img">
      <img src="https://static.etcmall.cn/etcissue/trucking/no_data.png" class="img_size">
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="less" scoped>
  .hint_info{
    background-color: #FFFFFF;
    padding: 110px 0px 41px 0px;
    .hint{
      width: 1rem;
      height: 1rem;
      padding: 0px 14px 0px 0px;
      margin: 0px 0px -3px 0px;
    }
  }
  .hint_img{
    background-color: #FFFFFF;
    .img_size{
      width: 9rem;
      height: 9rem;
    }
  }

</style>